export const SAVE_DATA = 'SAVE_DATA';
export const LOGOUT = 'LOGOUT';